import React from 'react';

const InvitationOnly = ({ onSwitchToLogin }) => {
  return (
    <div>
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-floral-900">
            Bouqmark
          </h2>
          <p className="mt-2 text-sm text-floral-600">
            Employee Account Registration
          </p>
        </div>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-floral-100 mb-4">
              <svg className="h-6 w-6 text-floral-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 0h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-floral-900 mb-2">Invitation Only</h2>
            <p className="text-floral-700 mb-6">
              Account registration is restricted to invited employees only. Please contact your administrator to receive an account invitation.
            </p>
            <p className="text-sm text-gray-600 mb-6">
              New employees must be added by an administrator through the admin panel. If you need access, please speak with your manager or system administrator.
            </p>
            <button
              onClick={onSwitchToLogin}
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-floral-600 hover:bg-floral-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-floral-500"
            >
              Back to Sign In
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvitationOnly;